import { useEffect, useState, useRef } from "react";
import { inject, observer } from 'mobx-react';
import { useNavigate } from "react-router-dom";
import { Input, InputPassword, Button } from "../../components";
import { AuthService } from "../../services";
import { UserIcon } from '@heroicons/react/solid'
import moment from 'moment'
import Authentication from "../../Authentication";
import { Carousel } from 'antd';
import './styles.css'
import { get, isEmpty } from "lodash"
import i18n from '../../i18n'
import { useTranslation } from 'react-i18next'
import Cookies from 'js-cookie';

const contentStyle: React.CSSProperties = {
  height: '100vh',
  color: '#fff',
  lineHeight: '160px',
  textAlign: 'center',
  background: '#364d79',
};


const Singin = inject("authenStore", "commonStore")(observer((props) => {
  const { t } = useTranslation(['auth', 'common'])
  let authenStore = props.authenStore
  let commonStore = props['commonStore']
  const navigate = useNavigate();
  let { setCommonStore, getRememberMe } = commonStore
  let { getAccount, setCommonValue, getAccountAuth } = authenStore
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [signinMessage, setSigninMessage] = useState({
    success: true,
    message: ""
  })
  const [isHovered, setIsHovered] = useState(false);
  const [imageNews, setImageNews]: any = useState([])

  const inputRef: any = useRef(null);

  useEffect(() => {
    let { cookies_language, cookies_remember, cookies_popup_notify } = Cookies.get()
    if (isEmpty(cookies_remember)) Cookies.set('cookies_remember', false)
    if (isEmpty(cookies_popup_notify)) Cookies.set('cookies_popup_notify', false)

    changeLanguageContent(false, cookies_language || "th")
  }, [])

  const changeLanguageContent = (isChange = false, language = "th") => {
    let { cookies_language } = Cookies.get()

    if (!isEmpty(cookies_language) && !isChange) {
      Cookies.set('cookies_language', cookies_language)
      i18n.changeLanguage(cookies_language)
    }
    else if (isChange) {
      Cookies.set('cookies_language', language)
      i18n.changeLanguage(language)
    }
    else {
      Cookies.set('cookies_language', "th")
      i18n.changeLanguage("th")
    }
  }

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus()
    if (getRememberMe.username !== "" && getRememberMe.password !== "") {
      setUsername(getRememberMe.username)
      setPassword(getRememberMe.password)
    }
    getImage()
  }, [])

  const getImage = () => {
    AuthService.getNewsImage()
      .then((res: any) => {
        let { status, data } = res
        if (status === 200) {
          setImageNews(get(data, 'ads', []))
        }
      })
      .catch((err) => {
      })
  }

  const onSignin = async () => {
    setSigninMessage({ ...signinMessage, success: true, message: '' })

    let errorMessage = ""

    if (username.trim() === "" && password.trim() === "")
      errorMessage = "input_your_user_password"
    else if (username.trim() === "")
      errorMessage = "input_your_username"
    else if (password.trim() === "")
      errorMessage = "input_your_password"

    if (errorMessage !== "") {
      setSigninMessage({ ...signinMessage, success: false, message: errorMessage })
      return
    }

    setLoading(true)
    AuthService.login(username, password)
      .then((res: any) => {
        let { code, result, message, sys_message } = res?.data
        if (code === 200 && result) {
          result.timestamp = moment();

          result.menu.push({
            "role_id": 176,
            "menu_id": 1,
            "permission_code": "101",
            "main_code": "1100",
            "main_menu": "แดชบอร์ด",
            "sub_menu": "แดชบอร์ด",
            "is_read": true,
            "is_created": false,
            "is_updated": false,
            "is_deleted": false,
            "is_export": false,
            "is_print": false,
            "group_id": 17
          })

          setCommonValue({ accountAuth: result })
          navigate("/home-page")
        }
        else {
          setSigninMessage({ ...signinMessage, success: false, message: `${message} ${sys_message}` })
        }
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        setSigninMessage({ ...signinMessage, success: false, message: `${err}` })
      })
  }

  return (
    <Authentication>
      <div className="flex min-h-screen">
        <div className="relative hidden w-0 flex-1 lg:block">
          <Carousel autoplay={{ dotDuration: true }} autoplaySpeed={5000}>
            {
              imageNews.map((data, index) => (
                <div key={`news-${index}`}>
                  <div style={contentStyle}>
                    <img
                      className={`h-full w-full object-cover ${!isEmpty(data?.target_url) ? "cursor-pointer" : ""}`}
                      src={data?.src_url}
                      onClick={() => !isEmpty(data?.target_url) ? window.open(data?.target_url, '_blank') : null}
                    />
                  </div>
                </div>
              ))
            }
          </Carousel>
        </div>



        <div
          className="flex flex-1 flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-6 bg-white bg-cover bg-center"
          style={{ backgroundImage: `url('/Images/bg-signin-screen.png')` }}>

          <div className="layout flex h-full flex-col justify-between items-center py-0 px-6">

            {/* ===== ส่วนบน Logo + Form ===== */}
            <div className="w-full flex-1 flex items-center">
              <div className="mx-auto w-full max-w-sm lg:w-80">

                {/* Logo */}
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                  <img
                    className="mx-auto w-64"
                    src={`/Images/Logo-sigin-title.png`}
                  />
                </div>

                {/* Form */}
                <div className="mt-12 space-y-8">

                  {/* Username */}
                  <div>
                    <Input
                      onRef={(ref) => (inputRef.current = ref)}
                      label={t('login.username')}
                      hiddenLabel
                      rounded="rounded-3xl"
                      placeholder={t('login.username')}
                      labelStyle={{ color: 'rgb(142, 46, 43)' }}
                      inputStyle={{ height: 38 }}
                      size="md"
                      defaultValue={username}
                      icon={
                        <UserIcon
                          className="w-5 h-5"
                          style={{ color: 'rgb(142, 46, 43)' }}
                        />
                      }
                      iconPosition="start"
                      onChange={(e) => setUsername(e.target.value)}
                      onKeyDown={(e) => e.key === 'Enter' && onSignin()}
                    />
                  </div>

                  {/* Password */}
                  <div>
                    <InputPassword
                      label={t('login.password')}
                      hiddenLabel
                      placeholder={t('login.password')}
                      rounded="rounded-3xl"
                      labelStyle={{ color: 'rgb(142, 46, 43)' }}
                      size="md"
                      defaultValue={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyDown={(e) => e.key === 'Enter' && onSignin()}
                    />
                  </div>

                  {/* Remember User */}
                  <div className="flex items-center">
                    <input
                      id="remember-me"
                      name="remember-me"
                      type="checkbox"
                      defaultChecked={
                        getRememberMe?.username !== '' &&
                        getRememberMe?.password !== ''
                      }
                      className="cursor-pointer h-5 w-5 border-gray-300 rounded text-primary-500"
                      onClick={(e: any) => {
                        if (
                          username.trim() &&
                          password.trim() &&
                          e.target?.checked
                        ) {
                          setCommonStore({ rememberMe: { username, password } });
                        } else {
                          setCommonStore({
                            rememberMe: { username: '', password: '' },
                          });
                        }
                      }}
                    />
                    <label
                      htmlFor="remember-me"
                      className="ml-2 block text-sm text-white"
                    >
                      {t('login.remember_user')}
                    </label>
                  </div>

                  {/* Button */}
                  <div>
                    <Button
                      text="Get Started"
                      type="white"
                      width="w-full"
                      size="lg"
                      rounded="rounded-3xl"
                      loading={loading}
                      onClick={onSignin}
                    />
                  </div>

                  {/* Error */}
                  <div
                    className={`rounded-md p-2 bg-danger-200 text-danger-800 text-sm ${signinMessage.success && 'sr-only'
                      }`}
                  >
                    {t(signinMessage.message)}
                  </div>
                </div>
              </div>
            </div>

            {/* ===== Footer ===== */}
            <div className="w-full">
              <div className="flex flex-col items-center">
                {/* SGS Logo บน */}
                <div className="justify-items-end w-full">
                  <img
                    className="h-24 w-auto"
                    src={`/icons/sgs_iso_back.png`}
                  />

                </div>
                {/* Copyright ติด footer */}
                <span
                  className="text-xs sm:text-sm mt-1"
                  style={{ color: 'rgb(142, 46, 43)' }}
                >
                  ©2026 PALMIST TECH. ALL RIGHTS RESERVED.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Authentication>
  )
}))

export default (Singin)